<template>
  <b-form-group v-slot="{ ariaDescribedby }">
    <b-form-radio-group
      v-model="model"
      v-if="model"
      :options="options"
      :aria-describedby="ariaDescribedby"
      button-variant="outline-primary"
      name="radio-btn-outline"
      buttons
    />
  </b-form-group>

</template>

<script>
import {BFormGroup, BFormRadioGroup, BModal} from "bootstrap-vue";

export default {
  components: {
    BModal,
    BFormGroup,
    BFormRadioGroup,
  },
  data() {
    return {
      options: [
        { text: "الكل", value: "all" },
        { text: "معاملات الإعلام", value: "new" },
        { text: "قيد المعالجة", value: "open" },
        { text: "بحاجة استدراك", value: "need_review" },
        { text: "المرفوضة", value: "rejected" },
        { text: "المقبولة", value: "accepted" },
      ],
      model: "all",
    };
    
  },

  watch: {
    model(val) {
      this.$emit("filterChanged", val);
    },
  },
};
</script>
